import { render, staticRenderFns } from "./message-item.vue?vue&type=template&id=3d6b4005&scoped=true"
import script from "./message-item.vue?vue&type=script&lang=js"
export * from "./message-item.vue?vue&type=script&lang=js"
import style0 from "./message-item.vue?vue&type=style&index=0&id=3d6b4005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6b4005",
  null
  
)

export default component.exports